// extracted by mini-css-extract-plugin
export default {"mainTitle":"landing_mainTitle__ml-Bq","nameTitle":"landing_nameTitle__jQC+1","subTitle":"landing_subTitle__Q8Bbi"};